/**
 * Redux tools.
 *
 * @module redux
 * @license Apache-2.0
 * @author drmats
 */
import { choose } from "./func";
export var createReducer = function createReducer() {
  var initState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (actions) {
    var defaultAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (s, _a) {
      return s;
    };
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return choose(action.type, actions, defaultAction, [state, action]);
    };
  };
};